/* eslint-disable max-len */

import React from 'react'
import { ShimmerBadge, ShimmerTable } from 'react-shimmer-effects'

export default function Skeleton({type}) {
    return (
        <div>
            <div className="flex md:justify-between justify-start md:items-center items-start md:flex-row flex-col lg:mx-12 ml-0 mt-2">
                <ul className="nav nav-pills flex flex-row list-none pl-0 mb-4 mt-5 md:ml-12 ml-3" id="pills-tab" role="tablist">
                    <li className="nav-item mr-[70px]" role="presentation">
                        <a href="#pills-home" className="nav-link block active  myOrders relative text-xs21 font-semibold text-[#555259]" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true"><ShimmerBadge/></a>
                    </li>
                    {/* <li className="nav-item" role="presentation">
                        <a href="#pills-profile" className="nav-link block myOrders relative text-xs21 font-semibold text-[#555259] draft-order1" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false"><ShimmerBadge/></a>
                    </li> */}
                </ul>
                <div className="filter">
                    <div className="flex mb-3 mt-3 mx-2 md:justify-end justify-strat items-center w-full">
                        <button type="button" className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px]"style={{border:'2px solid #E9EDF4'}} data-bs-toggle="modal" data-bs-target="#filtermodal">
                            <ShimmerBadge/>
                        </button>
                    </div>
                </div>
            </div>
            <ShimmerTable className="pt-7" row={10} col={2} />
        </div>
    )
}
